import Vue from 'vue'
import axios from 'axios'
import URITemplate from 'urijs/src/URITemplate'
import store from '@/store'
import { msgTypes } from '@/const'

var URI = require('urijs')

const http = axios.create({
  timeout: 30000
})

// Add a request interceptor
http.interceptors.request.use(function (config) {
  // Do something before request is sent
  // Added Token if exist
  if (store.state.token.token) {
    config.headers.common['x-auth-token'] = store.state.token.token
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
http.interceptors.response.use(function (response) {
  // Do something with response data
  // As maverick app requires login for all pages we do not need to do mavpermit check here
  return response
}, function (error) {
  // Do something with response error
  if (error.response) {
    // There are response for this error
    if (error.response.headers && error.response.headers.mavpermit && error.response.headers.mavpermit === 'false') {
      // Session has terminated
      // Instead of launch expired screen, we will do a popup to make user reload screen (refresh state)
      // Router.push({ name: 'expired' })
      if (store.state.app.init !== 0) {
        store.dispatch('logout')
      }
    } else {
      if (error.response.status === 403) {
        // Prompt user invalid access
        // One way is to redirect to 403 page, but diff page has diff ways of handling.
        // So we shall just do a prompt here
        Vue.prototype.$snotify.error('You do not have access to this resource')
      }
    }
  } else if (error.request) {
    // console.log(error.request)
    // Request was made, but no response was received
    // We will massage the data and pass back
    let errMsg = {
      messages: [{
        message: 'Failure to get a response from the server. Please try again later.',
        type: msgTypes.ERROR
      }]
    }
    Vue.prototype.$snotify.warning('Failure to get a response from the server. Please try again later.')

    let response = {
      config: error.config,
      data: errMsg,
      request: error.request,
      status: error.request.status,
      statusText: ''
    }
    error.response = response
  }
  return Promise.reject(error)
})

export const expandURI = (uri, val) => {
  return new URITemplate(uri).expand(val)
}

export const filterQuery = (uri, filters, sortBy, descending = false) => {
  if (filters) {
    let result = {}
    Object.keys(filters).forEach(function (key) {
      const val = filters[key]
      if (val !== null && val !== '') {
        Object.assign(result, {
          // [key]: Object.prototype.toString.call(val) === '[object Date]' ? formatDisplayDate(val) : val
          [key]: val
        })
      }
    })
    if (sortBy) {
      Object.assign(result, {
        sort: sortBy,
        sortType: descending ? 'desc' : 'asc'
      })
    }
    return new URI(uri).addSearch(result).valueOf()
  } else {
    return uri
  }
}

export default http
